// Contenu à faire valider par un juriste.
// Les repères [À COMPLÉTER : …] signalent les informations encore inconnues :
// ne rien inventer, les remplacer par les données exactes.
import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection, ToComplete } from '../components/LegalLayout';
import { contactInfo } from '../config/siteConfig';
import { siteInfo } from '../mockData';

const linkClass = 'text-[#21167D] underline underline-offset-2';

const PrivacyPolicy = () => (
  <LegalLayout title="Politique de confidentialité">
    <LegalSection title="Responsable du traitement">
      <p>
        {siteInfo.name}, {siteInfo.title.charAt(0).toLowerCase() + siteInfo.title.slice(1)}, {contactInfo.address}.
        Contact :{' '}
        <a href={`mailto:${contactInfo.email}`} className={`${linkClass} break-all`}>{contactInfo.email}</a>.
        {' '}<ToComplete>confirmer l'identité du responsable du traitement</ToComplete>
      </p>
    </LegalSection>

    <LegalSection title="Données collectées">
      <p><strong>Formulaire de prise de rendez-vous :</strong> nom, adresse email, numéro de téléphone, date et durée du rendez-vous demandé.</p>
      <p><strong>Formulaire de contact :</strong> nom, adresse email, numéro de téléphone, message.</p>
      <p>
        Merci de ne transmettre aucune information médicale par ces formulaires : elles ne sont pas nécessaires pour
        traiter votre demande.
      </p>
    </LegalSection>

    <LegalSection title="Finalités">
      <ul className="list-disc pl-6 space-y-1">
        <li>Gérer les demandes de rendez-vous : confirmation, refus, rappel et annulation.</li>
        <li>Répondre aux messages envoyés par le formulaire de contact.</li>
      </ul>
    </LegalSection>

    <LegalSection title="Base légale">
      <p><ToComplete>base légale de chaque traitement (prise de rendez-vous, formulaire de contact)</ToComplete></p>
    </LegalSection>

    <LegalSection title="Destinataires et sous-traitants">
      <p>
        Les données sont destinées uniquement à {siteInfo.name}. Elles sont traitées, pour son compte, par les
        prestataires suivants :
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li><strong>Google</strong> : agenda des rendez-vous et messagerie.</li>
        <li><strong>Cloudflare</strong> : hébergement du site et vérification anti-robot du formulaire de prise de rendez-vous (Turnstile).</li>
        <li><strong>Resend</strong> : envoi des emails liés aux demandes de rendez-vous et aux messages.</li>
        <li><strong>Google Fonts</strong> : chargement des polices de caractères du site (votre adresse IP est transmise à Google lors de l'affichage des pages).</li>
      </ul>
      <p>
        Ces prestataires peuvent traiter des données en dehors de l'Union européenne.{' '}
        <ToComplete>pays concernés et garanties encadrant ces transferts pour chaque prestataire</ToComplete>
      </p>
    </LegalSection>

    <LegalSection title="Durées de conservation">
      <ul className="list-disc pl-6 space-y-1">
        <li><strong>Demandes de rendez-vous :</strong> <ToComplete>durée de conservation</ToComplete></li>
        <li><strong>Messages du formulaire de contact :</strong> <ToComplete>durée de conservation</ToComplete></li>
      </ul>
    </LegalSection>

    <LegalSection title="Vos droits">
      <p>
        Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de limitation du
        traitement de vos données.
      </p>
      <p>
        Pour les exercer, écrivez à <ToComplete>adresse email ou postale à utiliser pour exercer ses droits</ToComplete>.
      </p>
      <p>
        Si vous estimez que vos droits ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL
        (Commission nationale de l'informatique et des libertés) :{' '}
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className={linkClass}>www.cnil.fr</a>.
      </p>
    </LegalSection>

    <LegalSection title="Cookies et mesure d'audience">
      {/* À vérifier avec le juriste : le widget Cloudflare Turnstile de la page de réservation. */}
      <p>Le site ne dépose aucun cookie et n'utilise aucun outil de mesure d'audience.</p>
    </LegalSection>

    <p className="text-sm text-[#4A4458]">
      Voir aussi les <Link to="/mentions-legales" className={linkClass}>mentions légales</Link>.
    </p>
  </LegalLayout>
);

export default PrivacyPolicy;
